import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { ROUTES } from 'theSource/app/routes';
import { selectIsAuthenticated } from 'theSource/features/Login/services/selectors';

interface PublicOutletProps {
  children?: JSX.Element;
}

export const PublicOutlet = ({ children }: PublicOutletProps) => {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  return isAuthenticated ? (
    <Navigate to={ROUTES.main.home.path} /> //Go to private route if logged in
  ) : (
    <>
      {children}
      <Outlet /> {/* This is nested route */}
    </>
  );
};
